import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const photos = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/zyu7j65x_Rectangle%20176.png',
    title: 'Red Carpet Winners',
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/a82dmsmy_Rectangle%20175.png',
    title: 'Award Ceremony Winners',
  },
  {
    id: 3,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/ekulc3ms_Rectangle%20174.png',
    title: 'Award Presentation',
  },
  {
    id: 4,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/2a9qlpqk_Rectangle%20177.png',
    title: 'Gala Dinner',
  },
  {
    id: 5,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/9cvve513_Rectangle%20178%20%282%29.png',
    title: 'La Perla Spa Ceremony',
  },
  {
    id: 6,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/026mue4t_Rectangle%20179%20%281%29.png',
    title: 'Certificate Presentation',
  },
  {
    id: 7,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/oy61lh7y_Rectangle%20180%20%281%29.png',
    title: 'Gala Dinner Guests',
  },
  {
    id: 8,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/jdo3luld_Rectangle%20181%20%281%29.png',
    title: 'Winner Speech',
  },
  {
    id: 9,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/x7ekg78k_GMG09899.jpg',
    title: 'Event Audience',
  },
  {
    id: 10,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/cmj5euff_GMG09903.jpg',
    title: 'Summit Attendees',
  },
  {
    id: 11,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/z8yubn2z_GMG09905.jpg',
    title: 'Conference Participants',
  },
  {
    id: 12,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/ham25o0j_GMG09922.jpg',
    title: 'Distinguished Guests',
  },
  {
    id: 13,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/ixvw02a4_GMG09983.jpg',
    title: 'World Tech Summit Panel',
  },
  {
    id: 14,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/z0wf21r3_RAS00448.jpg',
    title: 'World AI Technology Expo Panel',
  },
  {
    id: 15,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/utq5ck14_RAS00851.jpg',
    title: 'Tech Summit Discussion',
  },
  {
    id: 16,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/3ztp2vs4_RAS01226.jpg',
    title: 'Keynote Speaker',
  },
  {
    id: 17,
    image: 'https://customer-assets.emergentagent.com/job_25158215-48c8-4c0f-9133-9d7af68b124e/artifacts/9lpykxkd_RAS01277.jpg',
    title: 'Agentic AI Panel Discussion',
  },
];

export const EventPhotosSection = () => {
  return (
    <section data-testid="event-photos-section" className="py-24 bg-[#0a0a0a]">
      <div className="w-full px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Event Gallery</p>
            <h2 className="font-montserrat text-4xl sm:text-5xl text-white font-bold">
              Event <span className="gradient-gold">Photos</span>
            </h2>
          </div>
          <Link
            to="/gallery"
            data-testid="view-all-photos"
            className="inline-flex items-center gap-2 text-[#D4AF37] font-medium uppercase tracking-wider hover:gap-3 transition-all duration-300"
          >
            View Full Gallery
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Photo Grid - Masonry Style */}
        <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4">
          {photos.map((photo) => (
            <div
              key={photo.id}
              data-testid={`event-photo-${photo.id}`}
              className="group relative overflow-hidden rounded-xl bg-[#121212] break-inside-avoid mb-5"
            >
              <img
                src={photo.image}
                alt={photo.title}
                className="w-full h-auto object-contain transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="font-montserrat text-white text-sm font-semibold">{photo.title}</span>
              </div>
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#D4AF37] rounded-xl transition-all duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
